import type React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ConsentBanner } from './components/ConsentBanner';
import { LanguageSwitcher } from './components/LanguageSwitcher';
import { Navigation } from './components/Navigation';
import { SoundCloudPlayer } from './components/SoundCloudPlayer';
import { ConsentProvider } from './contexts/ConsentContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { PlayerProvider } from './contexts/PlayerContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { HomePage, ImprintPage, NotFoundPage, PrivacyPage, ReleaseDetailPage } from './pages';

export const App: React.FC = () => {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <PlayerProvider>
          <ConsentProvider>
            <LanguageSwitcher />
            <Navigation />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/details/:release" element={<ReleaseDetailPage />} />
              <Route path="/details/:release/" element={<ReleaseDetailPage />} />
              <Route path="/imprint" element={<ImprintPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <SoundCloudPlayer />
            <ConsentBanner />
          </ConsentProvider>
        </PlayerProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
